import { Component } from '@angular/core';
import { Train } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { Plant } from 'src/app/models/plant.model';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Router } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { EventLogStateService } from '../train-state.service';

@Component({
  selector: 'app-train-list',
  templateUrl: './train-list.component.html',
  styleUrls: ['./train-list.component.scss'],
})
export class TrainListComponent {
  dtoptions: DataTables.Settings = {};
 
  trains: Train[] = [];
  plants: Plant[] = [];
  allTrainList: Train[] = [];
  loggedInUserRole: string;
  loggedinUserId: string;
  plantAndUserId: string;
  showTable = false;
  SelectedId: string = '';
  selectedPlantId: string;
  constructor(
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private stateService: EventLogStateService
  ) {}
 
  getSelectedId(e: any) {
    this.showTable = true;
    this.SelectedId = e.target.value;
    this.selectedPlantId = this.SelectedId;
 
    // Save this selection in state service
    this.stateService.setTrainFilter(this.SelectedId);
 
    // Load trains based on selection
    this.loadTrainsByPlantId(this.SelectedId);
  }
 
  loadTrainsByPlantId(plantId: string) {
    if (this.loggedInUserRole == 'Standard User') {
      this.plantAndUserId = plantId + 'Z' + this.loggedinUserId;
      this.trainService
        .GetAccessibleTrainListByPlantId(this.plantAndUserId)
        .subscribe({
          next: (response: Train[]) => {
            this.allTrainList = response;
            console.log('Trains loaded:', this.allTrainList);
          },
          error: (error: any) => {
            console.log('Error loading trains:', error);
          },
        });
    } else {
      this.trainService.getTrainByPlantId(plantId).subscribe({
        next: (response: Train[]) => {
          this.allTrainList = response;
          console.log('Trains loaded:', this.allTrainList);
        },
        error: (error: any) => {
          console.log('Error loading trains:', error);
        },
      });
    }
  }
 
  navigate(TId) {
    console.log(TId);
    var id = btoa(TId.toString());
    this.router.navigate(['/component/trains/edit/' + id]);
  }
 
  ngOnInit(): void {
    // this.SelectedId = this.plants.id || '';
    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    let loggedInuserRole = JSON.parse(
      atob(sessionStorage.getItem('currentUser')!)
    );
    this.loggedInUserRole = loggedInuserRole.role;
    this.loggedinUserId = loggedInuserRole.userId;
    if (loggedInuserRole.role == 'Standard User') {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId).subscribe({
        next: (plants) => {
          this.plants = plants;
          this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
          this.restoreSelection();
        },
      });
    } else {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
          this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
          this.restoreSelection();
        },
        error: (response) => {
          console.log(response);
        },
      });
    }

    this.plantService.selectedPlant$.subscribe(plantId => {

    if (plantId) {
      this.SelectedId = plantId.toString();
      this.selectedPlantId = this.SelectedId;
      this.showTable = true;

      this.loadTrainsByPlantId(this.SelectedId);
    }

  });
  }
 
  clearFilters(): void {
    this.SelectedId = '';
    this.allTrainList = [];
    this.showTable = false;
    this.stateService.clearTrainFilter();
    console.log('Filters cleared');
  }
 
  restoreSelection(): void {
    const saved = this.stateService.getTrainFilter();
 
    if (saved.plantId) {
      console.log('Restoring saved plant selection:', saved.plantId);
 
 
      this.SelectedId = saved.plantId;
      this.selectedPlantId = saved.plantId;
      this.showTable = true;
 
 
      this.loadTrainsByPlantId(saved.plantId);
    } else {
      console.log('No saved plant selection found');
    }
  }
}
 
 